import {DashboardType} from "../../model/dashboard/types";
import {DashboardConfig} from "../../model/dashboard/dashboard-config";
import {getRootProjects} from "../../modals/add-widget/categories/helprs";
import {WidgetType} from "../../model/widget/widget-type";
import {CounterType} from "../../widgets/constants/types";
import {generateUniqueId} from "../../../../gd/utils/misc/generate-unique-id";

export function timeReportsDashboardConfig() {


    const widgetsConfig: any = [
        {
            // "cardLayout": "none",
            "settings": {
                "userIds": [],
                "includeSubFolders": true,
                "daterange": {
                    "start": -30,
                    "end": 0
                }
            },
            "color": 6,
            "conditions": null,
            "title": "Time reporting by day",
            "gridPosition": {
                "y": 0,
                "h": 2,
                "w": 6,
                "x": 3
            },
            "type": "time-reported-by-day",
            "id": generateUniqueId()
        },
        {
            // "cardLayout": "none",
            "settings": {
                "includeSubFolders": true,
                "userIds": [],
                "type": "by-task",
                "groupBy": "userId",
                "daterange": {
                    "start": -30,
                    "end": 0
                }
            },
            "color": 6,
            "conditions": null,
            "title": "Time reports by User",
            "gridPosition": {
                "y": 4,
                "h": 3,
                "w": 12,
                "x": 0
            },
            "type": "time-report",
            "id": generateUniqueId()
        },
        {
            // "cardLayout": "none",
            "settings": {
                "userIds": [
                    // "Pe9zrT",
                    // "xshBlq",
                    // "9V5f4g",
                    // "fJiCNS",
                    // "JBnX5v"
                ],
                "daterange": false
            },
            "color": 6,
            "conditions": null,
            "title": "Summary",
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 12,
                "x": 0
            },
            "type": "time-reports-summary",
            "id": generateUniqueId()
        },
        {
            "cardLayout": "none",
            "settings": {
                "counterType": "time-reports",
                "label": "Hours"
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    {
                        "type": "date-relative-range",
                        "id": "cond1",
                        "value": {
                            "start": -7,
                            "end": 0
                        },
                        "systemFieldId": "timeReport.date"
                    }
                ],
                "logicalOperator": "AND"
            },
            "title": "Last 7 days",
            "gridPosition": {
                "y": 0,
                "h": 1,
                "w": 3,
                "x": 0
            },
            "type": "counter",
            "id": generateUniqueId()
        },
        {
            // "cardLayout": "none",
            "settings": {
                "counterType": "time-reports",
                "label": "Hours"
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    {
                        "type": "date-relative-range",
                        "id": "cond1",
                        "value": {
                            "start": -14,
                            "end": 0
                        },
                        "systemFieldId": "timeReport.date"
                    }
                ],
                "logicalOperator": "AND"
            },
            "title": "Last 14 days",
            "gridPosition": {
                "y": 1,
                "h": 1,
                "w": 3,
                "x": 0
            },
            "type": "counter",
            "id": generateUniqueId()
        },
        {
            // "cardLayout": "none",
            "settings": {
                "displayGrid": false
            },
            "color": 6,
            "text": "For detailed time reports and/or import exporting go to Tools → Reports & Analytics and refer to the Time Reports section.",
            "title": "Notes",
            "gridPosition": {
                "y": 0,
                "h": 1,
                "w": 1,
                "x": 9
            },
            "conditions": null,
            "type": "quick-notes",
            "id": generateUniqueId()
        }
    ]

    const dashboardConfig:DashboardConfig = {
        "type"      : DashboardType.CUSTOM,
        "widgets"   : widgetsConfig
    }

    return dashboardConfig
}

